import React, { useState } from "react";
import Navbar from "../navbar";
import Footer from "../footer";
import { Link } from "gatsby";
import SizeGuidePopup from "../sizeguidepopup";

import QuickyEnquiry from "../connectpage/productenquiry";

import "./style.scss";
export default function Productpage({ product }) {
  const {
    galleryImages,
    productName,
    productLogo,
    descriptionTitle,
    descriptionText,
    availableSizes,
    featuresText,
    featuresImage,
    warrantyImage,
    warrantyIcons,
    price,
    brochureLink,
    category,
  } = product;

  const [currentImage, setCurrentImage] = useState(galleryImages[0]);
  const [showSizeGuide, setShowSizeGuide] = useState(false);
  const [showForm, setShowForm] = useState(false);

  function toggleForm() {
    setShowForm(!showForm);
  }

  function toggleSizeGuide() {
    setShowSizeGuide(!showSizeGuide);
  }
  return (
    <div className="product">
      <Navbar />
      <SizeGuidePopup show={showSizeGuide} onClickClose={toggleSizeGuide} />

      {showForm && (
        <div className="product__quickenquiry">
          <button
            onClick={toggleForm}
            className="hospitality__quickenquiry__close"
          >
            <i className="fas fa-times"></i>
          </button>
          <h1>Quick Enquiry</h1>

          <QuickyEnquiry product={productName} />
        </div>
      )}
      <div className="product__content">
        <h1 className="heading-primary">{productName}</h1>
        <div className="product__container1">
          <div className="row">
            <div className="col col-12 col-lg-7">
              <div className="product__gallery">
                <div className="product__gallery__current">
                  <img
                    alt="Current Product Image"
                    className="product__gallery__current__img"
                    src={currentImage}
                  ></img>
                </div>

                <div className="product__gallery__thumbnails">
                  {galleryImages.map((img, i) => (
                    <div
                      onClick={() => {
                        setCurrentImage(img);
                      }}
                      className={`product__gallery__thumbnails__thumbnail ${
                        currentImage === img &&
                        "product__gallery__thumbnails__thumbnail--active"
                      }`}
                    >
                      <img
                        alt="Product Image"
                        className="product__gallery__thumbnails__thumbnail__img"
                        src={img}
                      ></img>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col col-12 col-lg-5">
              <small
                style={{ textTransform: "uppercase", fontWeight: "bold" }}
                className="product_navigation"
              >
                <a style={{ textDecoration: "none", color: "black" }} href="/">
                  home
                </a>{" "}
                >{" "}
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href="/kids-mattress/"
                >
                  Kids Series
                </a>{" "}
                > {productName}
              </small>
              <div className="product__description">
                {productLogo && (
                  <img
                    alt="Product Logo"
                    className="product__description__logo"
                    src={productLogo}
                  ></img>
                )}

                <div className="product__description__title">
                  {descriptionTitle}
                </div>

                <div
                  className="product__description__text"
                  dangerouslySetInnerHTML={{ __html: descriptionText }}
                ></div>

                <div className="product__description__available">
                  {availableSizes && (
                    <>
                      <span className="product__description__available__text">
                        Available in :
                      </span>
                      <span className="product__description__available__sizes">
                        {availableSizes}
                      </span>
                    </>
                  )}
                </div>

                {price && (
                  <div className="product__description__price">
                    {/* <span className="product__description__price__text">
                      Price:
                    </span> */}
                    <span className="product__description__price__amount">
                      {/* ₹10000 - ₹20000 */}
                      {price}
                    </span>
                  </div>
                )}

                {/* <div className="product__description__price-range">
                  Price: ₹10000 - ₹20000
                  <span className="product__description__available__text">
                </div> */}

                <div className="product__description__buttons">
                  <Link
                    className="product__description__buttons__btn"
                    to="/exclusive-stores/"
                  >
                    Locate A Store
                  </Link>
                  <button
                    onClick={toggleSizeGuide}
                    className="product__description__buttons__btn"
                  >
                    Size Guide
                  </button>
                  <button
                    onClick={toggleForm}
                    className="product__description__buttons__btn"
                  >
                    Quick Enquiry
                  </button>

                  {/* {brochureLink && (
                    <a
                      target="_blank"
                      className="product__description__buttons__btn"
                      href={brochureLink}
                    >
                      Brochure
                    </a>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <h2 className="heading-primary">Features</h2>
        <div className="product__container2">
          <div className="row">
            <div className="col col-12 col-lg-6">
              <div className="product__features__left">
                {featuresText.map((text, i) => (
                  <div className="product__features__textcard">{text}</div>
                ))}
              </div>
            </div>
            <div className="col col-12 col-lg-6">
              {featuresImage && (
                <img
                  alt="Product Features"
                  className="product__features__img"
                  src={featuresImage}
                ></img>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="product__container3">
        <div className="row">
          <div className="col col-12 col-lg-6">
            <div className="product__warranty__icons">
              {warrantyIcons.map((icon, i) => (
                <div className="product__warranty__icons__icon">
                  <img alt="product icons" src={icon} />
                </div>
              ))}
            </div>
          </div>

          <div className="col col-12 col-lg-6">
            <div className="product__warranty">
              {warrantyImage && (
                <img
                  alt="Product Warranty"
                  className="product__warranty__img"
                  src={warrantyImage}
                ></img>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
